import React from 'react'

export default function BidOutbidLabel({
  children = 'Outbid',
}: {
  children?: string | React.ReactElement
}) {
  return (
    <div
      className={`flex w-max py-1.5 px-2 border border-bidfta-red
           text-12 md:text-10 text-bidfta-red bg-white font-semibold items-center`}
    >
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7.85605" cy="8.53137" r="7.64841" fill="#FF0000" />
        <line
          x1="5.03633"
          y1="11.2355"
          x2="10.4446"
          y2="5.82725"
          stroke="white"
          strokeWidth="0.849823"
        />
        <line
          x1="10.4445"
          y1="11.2355"
          x2="5.03629"
          y2="5.82724"
          stroke="white"
          strokeWidth="0.849823"
        />
      </svg>
      <span className="block pl-1 pt-0.5">{children}</span>
    </div>
  )
}
